import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { DashboardNavbar } from './DashboardNavbar';

export default function DashboardLayout() {
  return (
    <div className="min-h-screen sg-admin-app flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 xl:ml-64">
        <DashboardNavbar />
        <main className="flex-1 overflow-y-auto px-6 md:px-8 py-7 pb-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
